import React from 'react'
import { Icon } from '@fluentui/react/lib/Icon'
import { MenuHeader, Button, ButtonSort, FilterForm } from '../index'
import PropTypes from 'prop-types'

const SwitcherStartEnd = () => <Icon iconName="SwitcherStartEnd" className="ms-SwitcherStartEnd text-xl" />;
const Filter = () => <Icon iconName="Filter" className="ms-Filter text-xl" />;

const FloatingFilter = ({onSubmit}) => {
  const [isOpen, setIsOpen] = React.useState(false)

  const handleClick = () => {
    setIsOpen(false)
    onSubmit()
  }

  return (
    <div className="lg:hidden">

      {/* Trigger */}
      <div className="fixed bottom-0 fixed-center-horizontal mb-8">
        <div className="bg-white rounded rounded-full w-auto mx-auto text-center" style={{boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.15)'}}>
          <div className="flex items-center justify-center">
            <div className="rounded rounded-l-full py-2 px-4" onClick={() => setIsOpen('sort')}>
              <div className="text-gray-999 text-xs font-bold flex items-center">
                <div className="mr-2"><SwitcherStartEnd /></div>
                <div>Sort</div>
              </div>
            </div>
            <div style={{height: '23px', width: '1px', background: '#ddd'}}/>
            <div className="rounded rounded-r-full py-2 px-4" onClick={() => setIsOpen('filter')}>
              <div className="text-primary text-xs font-bold flex items-center">
                <div className="mr-2"><Filter /></div>
                <div>Filter</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Filter Menu */}
      {
        isOpen === 'filter' &&
        <div className="fixed left-0 top-0 h-screen w-full bg-white overflow-y-auto pb-10" style={{zIndex: 901}}>
          <MenuHeader className="bg-white z-10 fixed top-0 left-0 w-full" title="Filter" onClose={setIsOpen}/>
          <div className="p-5 pt-24">
            <FilterForm id="floating-filter-form" />
          </div>
          <div className="w-full fixed bottom-0">
            <Button style={{borderRadius: 0}} onClick={handleClick}>Terapkan</Button>
          </div>
        </div>
      }

      {/* Sort Menu */}
      {
        isOpen === 'sort' &&
        <div className="fixed left-0 top-0 h-screen w-full bg-white overflow-y-auto pb-10" style={{zIndex: 901}}>
          <MenuHeader title="Sort" onClose={setIsOpen}/>
          <div className="p-5">
            <ButtonSort className="mr-3 mb-3">Alphabet</ButtonSort>
            <ButtonSort className="mr-3 mb-3" active>Newest</ButtonSort>
            <ButtonSort className="mr-3 mb-3">Oldest</ButtonSort>
            <ButtonSort className="mr-3 mb-3">Popular</ButtonSort>
          </div>
        </div>
      }
    </div>
  )
}

FloatingFilter.propTypes = {
  onSubmit: PropTypes.func
}

FloatingFilter.defaultProps = {
  onSubmit: () => {}
}

export { FloatingFilter }